import { BaseResourceApi, type IResourceApiContext } from './common'
import { GeneratedActivationApi } from './generated/activations'
import { GeneratedCampaignApi } from './generated/campaigns'
import { GeneratedDistributionApi } from './generated/distributions'
import { GeneratedInteractiveApi } from './generated/interactives'
import { GeneratedProductionApi } from './generated/productions'
import { UserMediaApi } from './user-media'

export class CurrentUserApi extends BaseResourceApi {
  distributions: GeneratedDistributionApi
  productions: GeneratedProductionApi
  userMedia: UserMediaApi
  campaigns: GeneratedCampaignApi
  interactives: GeneratedInteractiveApi
  activations: GeneratedActivationApi
  constructor (ctx: IResourceApiContext) {
    super(ctx)
    this.distributions = new GeneratedDistributionApi(this.ctx, { currentUser: true })
    this.activations = new GeneratedActivationApi(this.ctx, { currentUser: true })
    this.productions = new GeneratedProductionApi(this.ctx, { currentUser: true })
    this.userMedia = new UserMediaApi(this.ctx, { currentUser: true })
    this.campaigns = new GeneratedCampaignApi(this.ctx, { currentUser: true })
    this.interactives = new GeneratedInteractiveApi(this.ctx, { currentUser: true })
  }
}
